import { selector } from 'recoil';
import platformAtom from '../atom/platform';

const displayStores = selector<Array<string>>({
  key: 'displayStores',
  get: ({ get }) => {
    const platform = get(platformAtom);

    return platform.displayStores;
  },
});

export default displayStores;
